import React from 'react';

// Generated from the LegalApp design canvas.
export default function SpotOfficer({ style }) {
  style = { ...{  }, ...style };
  return (
    <svg className="lp-spot-iso" viewBox="-113.9 -45.0 271.1 200.0" role="img" aria-label="Illustration: a stack of case files beside an investigation checklist" style={style}>
    <polygon points="147.2,85.0 43.3,145.0 43.3,137.0 147.2,77.0" fill="#C2D4F6" />
    <polygon points="-103.9,60.0 43.3,145.0 43.3,137.0 -103.9,52.0" fill="#E1EAFB" />
    <polygon points="0.0,-8.0 147.2,77.0 43.3,137.0 -103.9,52.0" fill="#FFFFFF" />
    <polygon points="31.2,62.0 -12.1,87.0 -12.1,80.0 31.2,55.0" fill="#D7861F" />
    <polygon points="-67.5,55.0 -12.1,87.0 -12.1,80.0 -67.5,48.0" fill="#F2A33A" />
    <polygon points="-24.2,23.0 31.2,55.0 -12.1,80.0 -67.5,48.0" fill="#FFCB7E" />
    <polygon points="31.2,53.0 -13.9,79.0 -13.9,72.0 31.2,46.0" fill="#BCD1F8" />
    <polygon points="-71.0,46.0 -13.9,79.0 -13.9,72.0 -71.0,39.0" fill="#E4EDFD" />
    <polygon points="-26.0,13.0 31.2,46.0 -13.9,72.0 -71.0,39.0" fill="#FFFFFF" />
    <polygon points="36.4,47.0 -6.9,72.0 -6.9,65.0 36.4,40.0" fill="#1A4DB8" />
    <polygon points="-62.4,40.0 -6.9,72.0 -6.9,65.0 -62.4,33.0" fill="#2563DE" />
    <polygon points="-19.1,8.0 36.4,40.0 -6.9,65.0 -62.4,33.0" fill="#4C81EC" />
    <polygon points="-19.1,20.0 5.2,34.0 -15.6,46.0 -39.8,32.0" fill="#FFFFFF" />
    <polygon points="110.9,90.0 105.7,93.0 105.7,1.0 110.9,-2.0" fill="#BCD1F8" />
    <polygon points="48.5,60.0 105.7,93.0 105.7,1.0 48.5,-32.0" fill="#E4EDFD" />
    <polygon points="53.7,-35.0 110.9,-2.0 105.7,1.0 48.5,-32.0" fill="#FFFFFF" />
    <polygon points="67.5,-17.0 86.6,-6.0 86.6,-14.0 67.5,-25.0" fill="#0B1B3F" />
    <polygon points="55.4,-2.0 63.2,2.5 63.2,-6.5 55.4,-11.0" fill="#F2A33A" />
    <polygon points="67.5,2.5 98.7,20.5 98.7,16.5 67.5,-1.5" fill="#2563DE" />
    <polygon points="55.4,15.0 63.2,19.5 63.2,10.5 55.4,6.0" fill="#F2A33A" />
    <polygon points="67.5,19.5 91.8,33.5 91.8,29.5 67.5,15.5" fill="#2563DE" />
    <polygon points="55.4,32.0 63.2,36.5 63.2,27.5 55.4,23.0" fill="#E4EDFD" />
    <polygon points="67.5,36.5 98.7,54.5 98.7,50.5 67.5,32.5" fill="#BCD1F8" />
    <polygon points="55.4,49.0 63.2,53.5 63.2,44.5 55.4,40.0" fill="#E4EDFD" />
    <polygon points="67.5,53.5 91.8,67.5 91.8,63.5 67.5,49.5" fill="#BCD1F8" />
    <g className="lp-iso-badge lp-float-b">
      <circle cx="114.9" cy="-8.0" r="16" fill="#F2A33A" />
      <circle cx="114.9" cy="-8.0" r="16" fill="none" className="lp-iso-badge-ring" />
      <path d="M108.1 -7.7 L113.3 -2.6 L122.1 -12.8" className="lp-iso-check" />
    </g>
    </svg>
  );
}
